import { createReducer } from "redux-create-reducer";
import AT from "../actionTypes";
import ReplaceTrash from "src/helpers/ReplaceTrash";

const initialState = {
  saving: false,
  original_ROSs: [],
  ROSs: [],
  physical_examinations: [],
  original_physical_examinations: [],
  vitals: [],
  original_vitals: null,
  medicine_administration: {
    pre_op: [],
    intra_op: [],
    post_op: [],
    discharge: [],
  },
  previous_medical_histories: [],
  previous_surgical_histories: [],
  allergies: [],
  medications: [],
  allMedications: [],
  allPreviousMedicalHistories: [],
  allPreviousSurgicalHistories: [],
  allAllergies: [],
  immunizations: [],
  family_histories: [],
  social_histories: [],
  vessel_states: [],
  original_vessel_states: [],
  all_normal_ros: null,
  original_all_normal_ros: null,
  all_normal_exam: null,
  original_all_normal_exam: null,
  can_copy_from_previous_visit: null,
  copy_from_last_visit_exam: null,
  original_copy_from_last_visit_exam: null,
  copy_from_last_visit_ros: null,
  original_copy_from_last_visit_ros: null,
  medication_administration: {},
  loadingEx: false,
  chiefComplaint: "",
  pre_operative: [],
  original_pre_operative: [],
  post_operative: [],
  original_post_operative: [],
  all_normal_post_operative: false,
  all_normal_pre_operative: false,
  original_all_normal_pre_operative: false,
  original_all_normal_post_operative: false,
  discharge: [],
  original_discharge: [],
  intra: [],
  loading_intra: false,
  complication: "",
  additional_plan_text: [],
  additional_plan_text_lymphedema: [],
  total_contrast_load: "",
  total_radiation_time: "",
  dose_area_product: null,
  calculated_dose_area_product: null,
  sedation_minutes: "",
  vital_signs: [],
  text_template: null,
  cpt_codes: [],
  icd_codes: [],
  leftRightOBL: null,
  condition_plans: {},
  rvu_arr: [],
  qualified_healthcare_provider: null,
  first_sedation_time: null,
  last_sedation_time: null,
  total_sedation_time: null,
  qualified_provider_name: null,
  ignore_bp_right: 0,
  ignore_bp_left: 0,
  return_followup_plans: [],
  preoperative_drugs: [],
  right_abi_text: "",
  left_abi_text: "",
  has_wrong_physical_exam: false,
  mips: [],
  vessel_states_angio: null,
  can_copy_intra_from_previous_visit: false,
  copy_intra_from_previous_visit: false,
  additional_plan_text: [],
  additional_plan_text_lymphedema: [],
  vascuqol6: [],
  has_pad: false,
};

const PATIENT_EXAMINATION_SET_DATA_SUCCEEDED = `${AT.PATIENT_EXAMINATION_SET_DATA}_SUCCEEDED`;
const RESET_VITAL_MEDICATION_SUCCEEDED = `${AT.RESET_VITAL_MEDICATION}_SUCCEEDED`;
const SET_VITAL_OG_SUCCEEDED = `${AT.SET_VITAL_OG}_SUCCEEDED`;
const SET_COPY_FROM_SUCCEEDED = `${AT.SET_COPY_FROM}_SUCCEEDED`;

const escapeRegexLiteral = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// Find `needle` in `haystack` only at list-separator boundaries (start, `, `, end, `,`).
// Prevents substring matches like "Alert" inside "Not Alert" or "Distress" inside "No Distress".
const findValueAtBoundary = (haystack, needle) => {
  if (!needle || !haystack) return -1;
  const pattern = new RegExp(`(?:^|,\\s)${escapeRegexLiteral(needle)}(?=$|,)`);
  const m = haystack.match(pattern);
  if (!m) return -1;
  // m[0] may include the leading boundary (", "); shift index forward to the needle itself.
  return m.index + m[0].length - needle.length;
};

// Parse default_comments into one segment per value. Uses each value's `replaced_value`
// as anchor; when the anchor cannot be found (typo / data mismatch), the segment is
// bounded by the next value's anchor position so the right slice of default_comments
// is still recovered.
const parseDefaultSegments = (defaultComments, values) => {
  const segments = [];
  let cursor = 0;
  for (let i = 0; i < values.length; i++) {
    const rv = values[i]?.replaced_value || "";
    const pos = rv ? defaultComments.indexOf(rv, cursor) : -1;
    if (pos !== -1) {
      segments.push(defaultComments.substring(pos, pos + rv.length));
      cursor = pos + rv.length;
      if (defaultComments.substr(cursor, 2) === ", ") cursor += 2;
    } else {
      let nextStart = defaultComments.length;
      for (let j = i + 1; j < values.length; j++) {
        const nextRv = values[j]?.replaced_value;
        if (nextRv) {
          const np = defaultComments.indexOf(nextRv, cursor);
          if (np !== -1) { nextStart = np; break; }
        }
      }
      const endPos = nextStart > cursor + 2 ? nextStart - 2 : nextStart;
      segments.push(defaultComments.substring(cursor, endPos));
      cursor = nextStart;
    }
  }
  return segments;
};

// Sync existing comments to the values' checked state without disturbing free text.
// For each value we look for its current token (option | replaced_value | default segment)
// at a separator boundary. If found, swap it to the target (option if checked, default
// segment otherwise). If not found, leave it alone — the user removed it intentionally.
// When NO list item is matched at all, comments is treated as pure free text and returned
// unchanged.
const syncCommentsToValues = (item) => {
  const values = item?.values || [];
  let comments = item?.comments || "";
  if (values.length === 0) return comments;

  const segments = parseDefaultSegments(item?.default_comments || "", values);

  const matches = values.map((v, i) => {
    const candidates = [v?.option, v?.replaced_value, segments[i]].filter(Boolean);
    let bestPos = -1;
    let bestText = null;
    for (const c of candidates) {
      const pos = findValueAtBoundary(comments, c);
      if (pos !== -1 && (bestPos === -1 || pos < bestPos)) {
        bestPos = pos;
        bestText = c;
      }
    }
    return { pos: bestPos, text: bestText, value: v, index: i };
  });

  if (!matches.some((m) => m.pos !== -1)) return comments;

  // Apply right-to-left so earlier replacements don't shift later positions.
  const ordered = matches.filter((m) => m.pos !== -1).sort((a, b) => b.pos - a.pos);
  ordered.forEach((m) => {
    const target = m.value?.checked
      ? m.value.option
      : (segments[m.index] || m.value?.replaced_value || "");
    if (target && m.text !== target) {
      comments = comments.substring(0, m.pos) + target + comments.substring(m.pos + m.text.length);
    }
  });

  return comments;
};

const logicRender = (value, type) => {
  const mixCheck = (value || []).map((r) => {
    // Guard: avoid producing literal "undefined, " when default_comments is missing.
    const defaultFallback = r?.default_comments ? `${r.default_comments}, ` : "";
    let commentsCheck = type ? r?.comments || defaultFallback : r?.comments || "";
    if (Array.isArray(r?.values) && commentsCheck) {
      commentsCheck = syncCommentsToValues({ ...r, comments: commentsCheck });
    }
    return {
      ...r,
      comments: ReplaceTrash(commentsCheck),
    };
  });
  return mixCheck || [];
};

const rerenderArr = (value, typeRos, TypeExam) => {
  if (value && value.length > 0) {
    if (typeRos == 1 || TypeExam == 1) {
      return logicRender(value, true);
    } else {
      // remove all
      // const mixCheck = (value || []).map((r) => {
      //   let commentsCheck = r?.comments || "";
      //   if (Array.isArray(r?.values) && commentsCheck) {
      //     (r?.values || []).map((row) => {
      //       commentsCheck = ReplaceTrash(commentsCheck, `${row?.replaced_value}, `);
      //       commentsCheck = ReplaceTrash(commentsCheck, `${row?.option}, `);
      //       //
      //       commentsCheck = ReplaceTrash(commentsCheck, `${row?.replaced_value},`);
      //       commentsCheck = ReplaceTrash(commentsCheck, `${row?.option},`);
      //     });
      //   }
      //   return {
      //     ...r,
      //     comments: commentsCheck ? ReplaceTrash(commentsCheck) : "",
      //   };
      // });
      return logicRender(value, false);
    }
  }
  return [];
};

export default createReducer(initialState, {
  [`${AT.UPDATE_COPY_INTRA}_SUCCEEDED`](state, action) {
    return {
      ...state,
      copy_intra_from_previous_visit: action?.payload?.status || false,
    };
  },
  [RESET_VITAL_MEDICATION_SUCCEEDED](state, action) {
    return Object.assign({}, state, {
      ...initialState,
    });
  },
  // intra
  [`${AT.SAVE_INTRA_OPERATIVE}_STARTED`](state, action) {
    return {
      ...state,
      loading_intra: true,
    };
  },
  [`${AT.SAVE_INTRA_OPERATIVE}_SUCCEEDED`](state, action) {
    return {
      ...state,
      loading_intra: false,
    };
  },
  [`${AT.LOAD_INTRA_OPERATIVE}_STARTED`](state, action) {
    return {
      ...state,
      loading_intra: true,
    };
  },
  [`${AT.LOAD_INTRA_OPERATIVE}_SUCCEEDED`](state, action) {
    const { angio_procedures, can_copy_hpi_from_previous_visit, copy_hpi_from_previous_visit } = action?.payload || {};
    return {
      ...state,
      intra: angio_procedures,
      can_copy_intra_from_previous_visit: can_copy_hpi_from_previous_visit,
      copy_intra_from_previous_visit: copy_hpi_from_previous_visit,
      loading_intra: false,
    };
  },
  //
  [`${AT.SAVE_CHIEF_COMPLAINT}_SUCCEEDED`](state, action) {
    return {
      ...state,
      loadingEx: false,
    };
  },
  [`${AT.SAVE_CHIEF_COMPLAINT}_STARTED`](state, action) {
    return {
      ...state,
      loadingEx: true,
    };
  },
  [`${AT.SAVE_APPOINTMENT_NOTES}_SUCCEEDED`](state, action) {
    return {
      ...state,
      loadingEx: false,
    };
  },
  [`${AT.SAVE_APPOINTMENT_NOTES}_STARTED`](state, action) {
    return {
      ...state,
      loadingEx: true,
    };
  },
  [`${AT.RESET_ALL_STATES}_SUCCEEDED`](state, action) {
    return {
      ...initialState,
    };
  },
  [`${AT.REMOVE_DATA_PATIENT}_SUCCEEDED`](state, action) {
    return {
      ...state,
      saving: false,
      ROSs: [],
      original_ROSs: [],
      physical_examinations: [],
      original_physical_examinations: [],
      vitals: [],
      original_vitals: [],
      previous_medical_histories: [],
      previous_surgical_histories: [],
      allergies: [],
      medications: [],
      allMedications: [],
      preoperative_drugs: [],
      allPreviousMedicalHistories: [],
      allPreviousSurgicalHistories: [],
      immunizations: [],
      family_histories: [],
      social_histories: [],
      vessel_states: [],
      original_vessel_states: [],
      pre_operative: [],
      discharge: [],
      post_operative: [],
      allAllergies: [],
      intra: [],
      all_normal_ros: null,
      all_normal_exam: null,
      original_all_normal_ros: null,
      original_all_normal_exam: null,
      chiefComplaint: "",
      can_copy_from_previous_visit: null,
      complication: "",
      additional_plan_text: [],
      additional_plan_text_lymphedema: [],
      total_contrast_load: "",
      total_radiation_time: "",
      dose_area_product: null,
      calculated_dose_area_product: null,
      sedation_minutes: "",
      text_template: null,
      right_abi_text: "",
      left_abi_text: "",
      vessel_states_angio: null,
      vascuqol6: [],
      has_pad: false,
    };
  },
  [`${AT.PATIENT_EXAMINATION_LOAD_INIT}_STARTED`](state, action) {
    return {
      ...state,
      loadingEx: true,
    };
  },
  [`${AT.ANGIO_PATIENT_SNAPSHOT_LOAD_INIT}_SUCCEEDED`](state, action) {
    if (action?.payload && Object.keys(action?.payload).length > 0) {
      const {
        immunizations,
        family_histories,
        social_histories,
        additional_plan_text,
        additional_plan_text_lymphedema,
        medication_administration,
        previous_medical_histories,
        previous_surgical_histories,
        allergies,
        medications,
        allMedications,
        allPreviousMedicalHistories,
        allPreviousSurgicalHistories,
        allAllergies,
        pre_operative,
        discharge,
        post_operative,
        all_normal_post_operative,
        all_normal_pre_operative,
        complication,
        leftRight,
        total_contrast_load,
        total_radiation_time,
        dose_area_product,
        calculated_dose_area_product,
        has_wrong_physical_exam,
        sedation_minutes,
        vital_signs,
        text_template,
        cpt_codes,
        icd_codes,
        condition_plans,
        rvu_arr,
        qualified_healthcare_provider,
        first_sedation_time,
        last_sedation_time,
        total_sedation_time,
        qualified_provider_name,
        return_followup_plans,
        preoperative_drugs,
        right_abi_text,
        left_abi_text,
        mips,
        vessel_states,
        vascuqol6,
        hasPad,
      } = action?.payload || {};

      return {
        ...state,
        complication,
        vessel_states_angio: vessel_states,
        total_contrast_load,
        medication_administration,
        total_radiation_time,
        additional_plan_text,
        additional_plan_text_lymphedema,
        dose_area_product,
        calculated_dose_area_product,
        immunizations,
        family_histories,
        social_histories,
        leftRightOBL: leftRight,
        previous_medical_histories,
        previous_surgical_histories,
        allergies,
        pre_operative,
        original_pre_operative: pre_operative,
        discharge,
        original_discharge: discharge,
        all_normal_post_operative,
        original_all_normal_post_operative: all_normal_post_operative,
        all_normal_pre_operative,
        original_all_normal_pre_operative: all_normal_pre_operative,
        post_operative,
        original_post_operative: post_operative,
        medications,
        allMedications,
        allPreviousMedicalHistories,
        allPreviousSurgicalHistories,
        allAllergies,
        vital_signs,
        text_template,
        has_wrong_physical_exam,
        cpt_codes,
        sedation_minutes,
        icd_codes,
        condition_plans,
        rvu_arr,
        qualified_healthcare_provider,
        first_sedation_time,
        last_sedation_time,
        total_sedation_time,
        qualified_provider_name,
        return_followup_plans,
        preoperative_drugs,
        right_abi_text,
        left_abi_text,
        mips,
        vascuqol6,
        has_pad: hasPad,
      };
    }
    return { ...state };
  },
  [SET_VITAL_OG_SUCCEEDED](state, action) {
    return {
      ...state,
      original_vitals: action?.payload?.value || [],
    };
  },
  [SET_COPY_FROM_SUCCEEDED](state, action) {
    return {
      ...state,
      [action?.payload?.scope]: action?.payload?.value || 0,
    };
  },
  [`${AT.PATIENT_EXAMINATION_LOAD_INIT}_SUCCEEDED`](state, action) {
    if (action?.payload && Object.keys(action?.payload).length > 0) {
      const {
        ROSs,
        physical_examinations,
        vitals,
        previous_medical_histories,
        previous_surgical_histories,
        allergies,
        medications,
        immunizations,
        family_histories,
        social_histories,
        ignore_bp_left,
        ignore_bp_right,
        vessel_states,
        allMedications,
        allAllergies,
        all_normal_ros,
        chiefComplaint,
        all_normal_exam,
        can_copy_from_previous_visit,
        copy_from_last_visit_ros,
        copy_from_last_visit_exam,
        condition_plans,
        vascuqol6,
        hasPad,
      } = action?.payload || {};

      return {
        ...state,
        ROSs: rerenderArr(ROSs, all_normal_ros, 0),
        physical_examinations: rerenderArr(physical_examinations, 0, all_normal_exam),
        original_ROSs: rerenderArr(ROSs, all_normal_ros, 0),
        original_physical_examinations: rerenderArr(physical_examinations, 0, all_normal_exam),
        original_vitals: null,
        vitals,
        previous_medical_histories,
        previous_surgical_histories,
        allergies,
        medications,
        immunizations,
        ignore_bp_left,
        ignore_bp_right,
        family_histories,
        social_histories,
        vessel_states,
        original_vessel_states: vessel_states,
        allMedications,
        allAllergies,
        all_normal_ros,
        original_all_normal_ros: all_normal_ros,
        all_normal_exam,
        original_all_normal_exam: all_normal_exam,
        can_copy_from_previous_visit,
        copy_from_last_visit_exam,
        original_copy_from_last_visit_exam: copy_from_last_visit_exam,
        copy_from_last_visit_ros,
        original_copy_from_last_visit_ros: copy_from_last_visit_ros,
        loadingEx: false,
        chiefComplaint,
        condition_plans,
        vascuqol6,
        has_pad: hasPad,
      };
    }

    return {
      ...state,
    };
  },
  [`${AT.PATIENT_EXAMINATION_COPY_LAST}_SUCCEEDED`](state, action) {
    const {
      ROSs,
      physical_examinations,
      all_normal_exam,
      all_normal_ros,
      copy_from_last_visit_exam,
      copy_from_last_visit_ros,
      vessel_states,
      vascuqol6,
    } = action?.payload || {};

    // Copy-last API does not return `default_comments`. Restore it from the original
    // load so downstream (logicRender, ExaminationROS) never sees an undefined value,
    // which otherwise materializes as the literal string "undefined, ".
    const originalPhysical = state.original_physical_examinations || [];
    const originalROSs = state.original_ROSs || [];

    const mergedPhysical = (physical_examinations || []).map((r) => {
      const orig = originalPhysical.find((p) => p.type === r.type);
      return {
        ...r,
        default_comments: r?.default_comments || orig?.default_comments || "",
      };
    });

    const mergedROSs = (ROSs || []).map((r) => {
      const orig = originalROSs.find((p) => p.type === r.type);
      return {
        ...r,
        default_comments: r?.default_comments || orig?.default_comments || "",
      };
    });

    return {
      ...state,
      ROSs: mergedROSs,
      vascuqol6: vascuqol6,
      physical_examinations: mergedPhysical,
      // all_normal_exam: all_normal_exam,
      // all_normal_ros: all_normal_ros,
      copy_from_last_visit_exam,
      copy_from_last_visit_ros,
      vessel_states,
    };
  },

  [`${AT.PATIENT_EXAMINATION_SET_NOMAL_CHECK}_SUCCEEDED`](state, action) {
    const { value, type } = action?.payload || {};
    if (type === "ROS") {
      return Object.assign({}, state, {
        ...state,
        all_normal_ros: value,
      });
    } else {
      return Object.assign({}, state, {
        ...state,
        all_normal_exam: value,
      });
    }
  },
  [PATIENT_EXAMINATION_SET_DATA_SUCCEEDED](state, action) {
    const { scope, examinations, type } = action?.payload || {};
    if (scope === "ROSs") {
      return Object.assign({}, state, {
        ROSs: rerenderArr(examinations, type, 0),
      });
    } else if (scope === "physical_examinations") {
      return Object.assign({}, state, {
        physical_examinations: rerenderArr(examinations, 0, type),
      });
    } else if (scope === "previous_medical_histories") {
      return Object.assign({}, state, {
        previous_medical_histories: examinations,
      });
    } else if (scope === "previous_surgical_histories") {
      return Object.assign({}, state, {
        previous_surgical_histories: examinations,
      });
    } else if (scope === "allergies") {
      return Object.assign({}, state, {
        allergies: examinations,
      });
    } else if (scope === "medications") {
      return Object.assign({}, state, {
        medications: examinations,
      });
    } else if (scope === "immunizations") {
      return Object.assign({}, state, {
        immunizations: examinations,
      });
    } else if (scope === "family_histories") {
      return Object.assign({}, state, {
        family_histories: examinations,
      });
    } else if (scope === "social_histories") {
      return Object.assign({}, state, {
        social_histories: examinations,
      });
    } else if (scope === "vitals") {
      return Object.assign({}, state, {
        vitals: examinations,
      });
    } else if (scope === "vessel_states") {
      return Object.assign({}, state, {
        vessel_states: examinations,
      });
    } else if (scope === "all_normal_exam") {
      return Object.assign({}, state, {
        all_normal_exam: examinations,
      });
    } else if (scope === "all_normal_ros") {
      return Object.assign({}, state, {
        all_normal_ros: examinations,
      });
    } else if (scope == "vascuqol6") {
      return Object.assign({}, state, {
        vascuqol6: examinations,
      });
    }
    return Object.assign({}, state);
  },

  [`${AT.PATIENT_EXAMINATION_SAVE}_STARTED`](state, action) {
    return {
      ...state,
      saving: true,
    };
  },
  [`${AT.PATIENT_EXAMINATION_SAVE}_SUCCEEDED`](state, action) {
    const { physical_examination } = action?.payload || {};
    return {
      ...state,
      saving: false,
    };
  },
});
